module.exports = __webpack_public_path__ + "img/380.55035c3e.png";